import { useNavigate, useParams } from 'react-router';
import { trackInAnalytics } from '@alfa-bank/newclick-alfa-metrics';
import { moneyRequestProxyApi } from '@alfa-bank/newclick-api';
import { useApiMethod } from '@alfa-bank/newclick-core/hooks';
import { useAtomValue, useSetAtom } from 'jotai';

import { ownerNameAtom, poolLimitsAtom } from '../atoms/money-pool-data/atom';
import { qrInfoAtom, qrInfoErrorAtom } from '../atoms/money-pool-qr/atom';
import { platformAtom } from '../atoms/platform/atom';
import { transferAmountAtom, transferErrorAtom } from '../atoms/transfer-amount/atom';
import { defaultError } from '../constants';
import { getFormatedAmount } from '../utils/get-formated-amount';
import { validateTransferAmount } from '../utils/validate-transfer-amount';

export const useHandleTransfer = () => {
    const navigate = useNavigate();
    const platform = useAtomValue(platformAtom);

    const { publicId = '' } = useParams<{ publicId: string }>();

    const ownerName = useAtomValue(ownerNameAtom);
    const transferAmount = useAtomValue(transferAmountAtom);
    const poolLimits = useAtomValue(poolLimitsAtom);

    const setQrInfo = useSetAtom(qrInfoAtom);
    const setQrInfoError = useSetAtom(qrInfoErrorAtom);
    const setTransferError = useSetAtom(transferErrorAtom);

    const { getMoneyPoolQRFetch, getMoneyPoolQRLoading } = useApiMethod(
        moneyRequestProxyApi.getMoneyPoolQR,
        {
            onSuccess: (data) => {
                const { acceptOperation, qrCodeUrl, errorText } = data;

                if (acceptOperation && qrCodeUrl) {
                    if (platform === 'desktop') {
                        setQrInfo(qrCodeUrl);

                        navigate('qr', { relative: 'path' });
                    } else {
                        window.location.href = qrCodeUrl;
                    }
                } else {
                    setQrInfoError(errorText || defaultError);
                }
            },
            onError: () => {
                setQrInfoError(defaultError);
            },
        },
    );

    const handleSubmit = () => {
        const error = validateTransferAmount(transferAmount, poolLimits);
        const transferSum = getFormatedAmount(transferAmount);

        trackInAnalytics('TRANSFER_BUTTON_CLICK', {
            publicId,
            transferSum,
        });

        if (error) {
            trackInAnalytics('TRANSFER_AMOUNT_VALIDATION_ERROR', {
                publicId,
                transferSum,
            });
            setTransferError(error);
        } else {
            getMoneyPoolQRFetch({
                moneyPoolPublicId: publicId,
                maskedOwnerName: ownerName,
                amount: transferAmount,
            });
        }
    };

    return { handleSubmit, loading: getMoneyPoolQRLoading };
};
